import { useStore } from "../../components/ApartmentFinder/State/Store"
import React from "react"
import { useState } from "react"
import background from "./background.png"
import cross from "./cross.svg"
import emailIcon from "./email.svg"
import copyIcon from "./copy.svg"
import "./FavouritesForm.css"

const FavouritesForm = props => {
  const { setShowForm } = props
  const [sending, setSending] = useState(false)
  const [name, setName] = useState("")
  const [email, setEmail] = useState("")
  const favourites = useStore(state => state.favourites)

  const url = `https://www.coronationsquare.london/share_apartments?units=${favourites.join(
    ","
  )}`

  const formSubmit = e => {
    setSending(true)
    e.preventDefault()
    const names = name.split(" ")
    const emailURL =
      "https://qqo4y7jd7c.execute-api.eu-west-2.amazonaws.com/dev/send"
    const apiKey = "SuslEuh0MU9WUeGbEjF6N83RLw84ikWq5pQqw7CK"
    fetch(emailURL, {
      method: "POST",
      mode: "no-cors",
      headers: {
        "x-api-key": apiKey,
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        from: "info@coronationsquare.london",
        to: email,
        bcc: "coronation.square@taylorwimpey.com",
        template: "leyton",
        language: "en",
        project: "leyton",
        data: {
          firstname: names[0],
          lastname: names.slice(1).join(" "),
          link: url
        }
      })
    }).then(() => {
      setShowForm(false)
    })
  }

  const copyToClipboard = string => {
    let textarea
    let result

    try {
      textarea = document.createElement("textarea")
      textarea.setAttribute("readonly", true)
      textarea.setAttribute("contenteditable", true)
      textarea.style.position = "fixed"
      textarea.value = string
      document.body.appendChild(textarea)
      textarea.focus()
      textarea.select()
      const range = document.createRange()
      range.selectNodeContents(textarea)
      const sel = window.getSelection()
      sel.removeAllRanges()
      sel.addRange(range)
      textarea.setSelectionRange(0, textarea.value.length)
      result = document.execCommand("copy")
    } catch (err) {
      result = null
    } finally {
      document.body.removeChild(textarea)
    }
    if (!result) {
      const isMac = navigator.platform.toUpperCase().indexOf("MAC") >= 0
      const copyHotkey = isMac ? "⌘C" : "CTRL+C"
      result = prompt(`Press ${copyHotkey}`, string)
      if (!result) {
        return false
      }
    }
    setShowForm(false)
    setSending(false)
    return true
  }

  const handleSend = url => {
    console.log("clck")
    copyToClipboard(url)
  }

  return (
    <div className="favourites-form-backdrop">
      <form className="favourites-form" onSubmit={formSubmit}>
        <img className="background" alt="" src={background} />
        <img
          className="cross"
          src={cross}
          alt="close"
          onClick={() => setShowForm(false)}
        />
        <div className="form-bottom" />
        <div className="grid">
          <div className="share">Share.</div>
          <div>
            <div className="buttons">
              {sending ? (
                <div style={{ width: "100px", height: "100px", padding: "3%" }}>
                  <div class="lds-ring-purp">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </div>
              ) : (
                <input type="image" src={emailIcon} border="0" alt="Submit" />
              )}
              <img src={copyIcon} alt="Copy" onClick={() => handleSend(url)} />
            </div>

            <div>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="Email"
                required={true}
              />
              <input
                style={{ marginTop: "4px" }}
                type="text"
                value={name}
                onChange={e => setName(e.target.value)}
                placeholder="Name"
                required={true}
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  )
}

export default FavouritesForm
